import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';

const ResultsTable = ({ data, historicalData, onError, onSelect }) => {
  const handleDownload = async () => {
    try {
      const zip = new JSZip();

      // Create the predictions Excel file
      const worksheetPredictions = XLSX.utils.json_to_sheet(data);
      const workbookPredictions = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbookPredictions, worksheetPredictions, 'Predictions');
      const excelBufferPredictions = XLSX.write(workbookPredictions, { bookType: 'xlsx', type: 'array' });
      zip.file(`tomato_yield_predictions_${new Date().toISOString().split('T')[0]}.xlsx`, excelBufferPredictions);

      // Create the historical data Excel file
      const worksheetHistorical = XLSX.utils.json_to_sheet(historicalData);
      const workbookHistorical = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbookHistorical, worksheetHistorical, 'Historical Data');
      const excelBufferHistorical = XLSX.write(workbookHistorical, { bookType: 'xlsx', type: 'array' });
      zip.file(`historical_data_${new Date().toISOString().split('T')[0]}.xlsx`, excelBufferHistorical);

      // Generate the zip file
      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, `tomato_yield_results_${new Date().toISOString().split('T')[0]}.zip`);
    } catch (error) {
      onError('Failed to download zip file: ' + error.message);
    }
  };

  const handleRowClick = (row) => {
      // Call the onSelect function with the selected variety and production area
      onSelect(row.Variety, row.ProductionArea);
    };

  return (
    <div className="results-section">
      <div className="results-header">
        <h2>Prediction Results</h2>
        <button className="download-btn" onClick={handleDownload}>
          Download Zip
        </button>
      </div>

      <div className="table-container">
        <table className="results-table">
          <thead>
            <tr>
              <th>Basic Material Number</th>
              <th>Variety</th>
              <th>Production Area</th>
              <th>Sowing Month</th>
              <th>Predicted Yield (g/m²/week)</th>
              <th>Clean Predicted Yield (g/m²/week)</th>
              <th>Data Source</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index} onClick={() => handleRowClick(row)} style={{ cursor: 'pointer' }}>
                <td>{row.BasicMaterialNumber}</td>
                <td>{row.Variety}</td>
                <td>{row.ProductionArea}</td>
                <td>{row.SowingMonth}</td>
                <td>{row.Predicted_base_rate_g_m2_week?.toFixed(2) || 'N/A'}</td>
                <td>{row.Clean_predicted_base_rate_g_m2_week?.toFixed(2) || 'N/A'}</td>
                <td>{row.Prediction_data_source || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ResultsTable;